import { Injectable, inject } from "@angular/core";
import {ToastController} from "@ionic/angular";
import {from, Observable} from "rxjs";
import {ETeamToastPosition} from "@team/enums/team-toast-position.enum";
import {IToastOptions} from "@shared/services/interfaces/toast-options.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedToastControllerService {
  private _toastController = inject(ToastController);


  /**
   * @name present
   * @memberof SharedToastControllerService
   * @description
   * Display a toast by params
   * @param message
   * @param position
   * @param duration
   * @param icon
   * @param color
   * @private
   */
  async present(message: string, position: ETeamToastPosition = ETeamToastPosition.Bottom, duration: number = 3000,
                icon: string = "", color: string = "dark"): Promise<void> {
    const toast = await this._toastController.create({
      message,
      duration,
      position,
      icon,
      color
    });

    await toast.present();
  }

  /**
   * @name observablePresent
   * @memberof SharedToastControllerService
   * @description
   * return an observable of toast
   * @param opts
   */
  observablePresent(
    opts: IToastOptions
  ): Observable<void> {
    const {
      message,
      position = ETeamToastPosition.Bottom,
      duration = 3000,
      icon = "",
      color = "dark"
    } = opts;
    return from(this.present(message, position, duration, icon, color));
  }
}
